// extracted by mini-css-extract-plugin
module.exports = {"input":"_1nq0scqQ41MDX8HTa4q78c","gray":"_2CQgK7Nq7LYhwDA2ImHJEV","btn":"_3cW0EgVz71rB1-1cZpXopm"};